import { useTranslation } from '@klv/hooks/useTranslation';

import Buttons from '@klv/molecules/buttons';
import Image from '@klv/atoms/image';
import TranslatedDate from '@klv/atoms/translated-date';
import Typography from '@klv/atoms/typography';

import type { IWhatsNewUpdate } from '@klv/organisms/whats-new-timeline/types';

import * as s from './styles/whats-new-result-item.module.css';


const WhatsNewResultItem = ({
  backgroundColor,
  post_topic:{ postTopic }, 
  release_type:{ releaseType }, 
  _highlightResult,
  title,
  templatesWhatsNewUpdate: {
    description,
    buttons,
    image,
    postDate,
  },
}: IWhatsNewUpdate) => {
  const { t } = useTranslation();
  
  const decodeHtmlEntities = (str: string): string => str?.replace(/&(?:amp|lt|gt|quot|#39|#96);/g, entity => ({ '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': '\'', '&#96;': '`' }[entity] || entity));
  
  const oppositeBackgroundColor = backgroundColor === 'dark' ? 'light' : 'dark';

  let displayDescription = description;
  let displayTitle = title;

  if (_highlightResult?.description?.value) {
    displayDescription = decodeHtmlEntities(_highlightResult.description.value);
  }
  if (_highlightResult?.title?.value) {
    displayTitle = decodeHtmlEntities(_highlightResult.title.value);
  }

  return (
    <div className={`${s.searchResult} ${backgroundColor === 'light' ? s.light : s.dark}`}>
      <div className={s.textContainer}>
        <div className={s.cardLabel}>
          {releaseType && (
            <>
              <div className={s.releaseType}>
                {t(`organisms_whatsNew_refinements_${releaseType}`)}
              </div>
              <span className={s.separator}>|</span>
            </>
          )}
          
          <span>
            <TranslatedDate date={postDate} options={{
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }}/>
          </span>
        </div>
        {postTopic && (
          <div className={s.postTopics}>
            {postTopic?.map((topic) => (
              <span className={s.postTopic} key={topic}>
                {t(`organisms_whatsNew_refinements_${topic}`)}
              </span>
            ))}
          </div>
        )}
        <Typography variant="h4Semibold" className={s.title} dangerouslySetInnerHTML={{ __html: displayTitle }}/>
        <Typography variant="paragraph2" className={s.description} dangerouslySetInnerHTML={{ __html: displayDescription }}/>
        {!!buttons?.length && <Buttons className={s.cardButtons} buttons={buttons} buttonColor={oppositeBackgroundColor} variants={['tertiary']}/> }
      </div>
      {!!image?.gatsbyImage && (
        <div className={s.imageContainer}>
          <Image className={s.image} altText={image.altText} imageData={image.gatsbyImage} />
        </div>
      )}
    </div>
  );
};

export default WhatsNewResultItem;
